import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

export const LoadingPlaceholder = styled(Flex)`
  position: relative;
  overflow: hidden;

  @keyframes loading {
    100% {
      transform: translateX(100%);
    }
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100px);
    background: linear-gradient(
      90deg,
      transparent,
      ${colors('white', 25)},
      transparent
    );
    animation: loading 0.8s infinite;
  }
`
